import DataValidationResults from './DataValidationResults'

export default DataValidationResults
